export default __webpack_public_path__ + "52caa75bf0f4d784dda4e348ac843d62.png";